/**
 * Constants for permissions — single source of truth for the frontend.
 * Match with backend permissions.
 */

export const CLIENT_MANAGEMENT_PERMISSION = [
  'clients.readOwn',
  'clients.readSharkTank',
  'clients.readByProjects',
  'clients.readAll',
  'clients.read',
];

/** Permissions required to access the beta Análisis feature (broad client read). */
export const USER_ANALYSIS_READ_PERMISSIONS = ['clients.readAll', 'clients.read'];

export const FORBIDDEN_ANALYSIS_PERMISSIONS = ['clients.readOwn', 'clients.readSharkTank', 'clients.readByProjects'];

/**
 * Permission identifying the "manager" role (Clientes - Manager). Roles are not exposed
 * to the frontend, only permissions, so this is the frontend proxy for "is manager".
 */
export const MANAGER_CLIENTS_PERMISSION = 'clients.readAll';

// TEMPLATES

export const SEND_TEMPLATE_PERMISSION = 'templates.send';

export const SCHEDULE_TEMPLATE_PERMISSION = 'templates.schedule';

/**
 * TEMPLATE_BATCH_PERMISSIONS
 * Permisos requeridos para crear campañas masivas y cancelarlas.
 * Usado para el botón de cancelar en la tabla de campañas.
 *
 * Matriz de permisos para Template Batches:
 * - templateSender.read → Ver página /template-sender y listar campañas (GET /templates/batches)
 * - templates.schedule OR templates.send → Cancelar campañas masivas (POST /templates/scheduled/:id/cancelBatch)
 */
export const TEMPLATE_BATCH_PERMISSIONS = [SCHEDULE_TEMPLATE_PERMISSION, SEND_TEMPLATE_PERMISSION];

// Acceso a la vista de gestión de template mediante /templates
export const TEMPLATES_PERMISSION = 'templates.manage';

/**
 * TEMPLATE_SENDER_READ_PERMISSION
 * Acceso a la vista de mensajería mediante /template-sender.
 * Permite ver la página, el wizard de envío y la tabla de campañas masivas.
 */
export const TEMPLATE_SENDER_READ_PERMISSION = 'templateSender.read';

// WHATSAPP FLOWS

export const WHATSAPP_FLOWS_READ_PERMISSION = 'whatsapp_flows.read';

export const WHATSAPP_FLOWS_MANAGE_PERMISSION = 'whatsapp_flows.manage';

// FUNNEL

/** Permission to manage funnel structure (create/edit/delete stages, open funnel settings). */
export const FUNNEL_UPDATE_PERMISSION = 'funnel.update';

// LEADS

export const LEAD_READ_PERMISSION = 'lead.read';

// SELLER DASHBOARD

export const SELLER_DASHBOARD_READ_PERMISSION = 'sellerDashboard.read';

// PARTNER CENTER

export const PARTNER_CENTER_PERMISSION = 'partnerCenter.read';
export const PARTNER_CONTENT_MANAGE_PERMISSION = 'partnerContent.manage';
export const FILES_READ_PERMISSION = 'files.read';
export const FILES_MANAGE_PERMISSION = 'files.manage';
export const FILES_SEND_PERMISSION = 'files.send';
export const FILES_READ_ALL_PERMISSION = 'files.readAll';
export const EXECUTIVE_FILES_READ_PERMISSIONS = [FILES_READ_PERMISSION, FILES_READ_ALL_PERMISSION];
export const SUPPORT_TICKETS_PERMISSION = 'support.tickets';
export const USERS_MANAGE_PERMISSION = 'users.manage';

// LOOKER

export const LOOKER_PERMISSION = 'reports.read';

export const COUNTRY_ADMIN_PERMISSION = 'partner.access';

export const ADMIN_PERMISSION = '*.*';

// DEV

export const DEV_USE_PERMISSION = 'dev.use';

/**
 * BROKERAGE_READ_PERMISSION
 * This permission is used to access the brokerage page (mortgage_partner role) —
 * a table view of mirror clients (mortgage derivations) for the partner's project.
 */
export const BROKERAGE_READ_PERMISSION = 'brokerage.read';
